import { render, staticRenderFns } from "./ProceduresSelection.vue?vue&type=template&id=9b262a02&scoped=true"
import script from "./ProceduresSelection.vue?vue&type=script&lang=js"
export * from "./ProceduresSelection.vue?vue&type=script&lang=js"
import style0 from "./ProceduresSelection.vue?vue&type=style&index=0&id=9b262a02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b262a02",
  null
  
)

export default component.exports